import { render, staticRenderFns } from "./company-no.vue?vue&type=template&id=3cb5e4de"
import script from "./company-no.vue?vue&type=script&lang=js"
export * from "./company-no.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports